import { useMediaQuery } from "react-responsive";
import { desktop } from "@ui/styles/utils";

export type SignupChannel = "email" | "phone";

export function useSignupStepCount(channel: SignupChannel): number {
	const isDesktop = useMediaQuery({ query: desktop });
	if (channel === "phone") {
		return 2;
	}
	if (isDesktop) {
		return 1;
	}
	return 2;
}
